namespace GeniuzPOS.LogManage {
    export interface LogUserPasswordChangeDateRow {
        UserId?: number;
        Username?: string;
        ShopId?: string;
        DisplayName?: string;
        Email?: string;
        PasswordChangeDate?: string;
    }

    export namespace LogUserPasswordChangeDateRow {
        export const idProperty = 'UserId';
        export const nameProperty = 'Username';
        export const localTextPrefix = 'LogManage.LogUserPasswordChangeDate';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            UserId = "UserId",
            Username = "Username",
            ShopId = "ShopId",
            DisplayName = "DisplayName",
            Email = "Email",
            PasswordChangeDate = "PasswordChangeDate"
        }
    }
}
